import { render, staticRenderFns } from "./userlogin.vue?vue&type=template&id=6bc2799e&"
import script from "./userlogin.vue?vue&type=script&lang=js&"
export * from "./userlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc2799e')) {
      api.createRecord('6bc2799e', component.options)
    } else {
      api.reload('6bc2799e', component.options)
    }
    module.hot.accept("./userlogin.vue?vue&type=template&id=6bc2799e&", function () {
      api.rerender('6bc2799e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/userlogin.vue"
export default component.exports